import {SimplePresentation} from "./SimplePresentationRunner";
import {Decadence} from "../../Decadence";
import {DecadenceWinConfig} from "../../config/DecadenceWinConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class DecadenceNormalWinPresentation extends SimplePresentation {

    constructor() {
        super("NormalWin");
    }

    shouldRun(): boolean {
        const winRatio = Decadence.model.spinWinRatio;
        return !DecadenceWinConfig.bigWinThresholdReached(winRatio, Decadence.model.numberOfActiveReels) && winRatio > 0 && !Decadence.model.brokeTheBank;
    }

    buildTimeline() {
        const tl = this.tl;
        tl.add(() => {
            const winLevel = DecadenceWinConfig.getWinConfig(Decadence.model.spinWinRatio);
            if(winLevel.sound && !Decadence.model.winBelowStake) {
                const sound = Decadence.model.spinWinRatio == 1 ? "winTiny" : winLevel.sound;
                Decadence.soundPlayer.playSound(sound);
            }
            const isTotalWin = Decadence.model.mode != GameMode.NORMAL || Decadence.model.nextMode != GameMode.NORMAL;
            Decadence.keypadPlugin.setWin(Decadence.model.accumulatedWin, isTotalWin, Decadence.model.winBelowStake);
        });
        tl.add(Decadence.reelView.playMonsterWin(), "<")
    }
}